import React  from 'react';

import SuccessStoryContent from "../content/SuccessStoryContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";

import { Helmet } from "react-helmet-async";

function SuccessStory() {
    return(
        <>
        <Helmet>
            <title>Success Stories | Suvivah</title>

            <meta
                name="description"
                content="Read inspiring success stories of couples who found their ideal life partners through Suvivah."
            />

            <meta
                name="keywords"
                content="Success Stories, Happy Couples, Matrimony, Suvivah"
            />

            <meta name="robots" content="index, follow" />
            <meta name="author" content="Suvivah" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#dc3545" />
            <meta property="og:site_name" content="Suvivah" />
            <meta property="og:locale" content="en_IN" />

            <link rel="canonical" href="https://suvivah.org/success-story" />

            <meta property="og:title" content="Success Stories | Suvivah" />
            <meta property="og:description" content="Real stories of successful marriages through Suvivah." />
            <meta property="og:image" content="https://suvivah.org/images/logo.png" />
        </Helmet>

        <Navbar />
        <SuccessStoryContent/>
        <Footer />        
        </>
    );
}

export default SuccessStory;